import React, { useEffect,  useRef, useState } from "react";

import { Row, Col, Button, Offcanvas } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import Cookies from "js-cookie";

import { format } from "date-fns";

import { FiMenu } from "react-icons/fi";
import { MdOutlineSystemUpdateAlt } from "react-icons/md";
import MaintenanceFilterBox from "../../../../components/FilterBox/MaintenanceFilter/MaintenanceFilter";
import MaintenanceDropDwonFilterBox from "../../../../components/FilterBox/MaintenanceFilter/MaintennanceDropDownFilter";
import MaintenanceTable from "../../../../components/Tables/MaintenanceTable";
import MaintenanceParentChild from "../../../../components/Tables/MaintenanceParentChild";
import {
  ItemVsSupplier,
  ItemVsSupplierFun,
  StoreFilters,
} from "../../../../Redux/Slice/Maintenance/MaintenanceSlice";
import { Loader } from "../../../../components/Loader/Loader";
import { useTheme } from "../../../../Themecontext/Themecontext";
import Calendar from "react-calendar";
import MaintenanceCelender from "../../../../components/Calendar/MaintenanceCelender";

export const ItemSupllierAnalysis = () => {
  const dispatch = useDispatch();

  const { Colourdata, DataMain } = useSelector((state) => state.ClientLogin);
  const { StoreFiltersdata, ItemVsSupplierdata } = useSelector(
    (state) => state.MaintenanceSlice,
  );

  const iscolour = Colourdata?.data?.find(
    (el) => el.ExeName === "MAINTENANCESTORE",
  );
  const iscolourDark = Colourdata?.data?.find(
    (el) => el.ExeName === "MAINTENANCESTOREDARK",
  );

  const { theme } = useTheme();
  const isdark = theme;
  const FinancialYear = Cookies.get("FinancialYear");
  const Firm = Cookies.get("Firm");

  const [showFilter, setShowFilter] = useState(false);
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [activeTable, setActiveTable] = useState("PARTYWISE");

  // Item Sub Group
  const [selectedItemSubGroup, setSelectedItemSubGroup] = useState("");
  const [selectedItemSubGroupId, setSelectedItemSubGroupId] = useState([]);

  // Item Group
  const [selectedItemGroup, setSelectedItemGroup] = useState("");
  const [selectedItemGroupId, setSelectedItemGroupId] = useState([]);

  // Item Name
  const [selectedItemName, setSelectedItemName] = useState("");
  const [selectedItemNameId, setSelectedItemNameId] = useState([]);


  const [dateRange, setDateRange] = useState([
    {
      startDate: null,
      endDate: null,
      key: "selection",
    },
  ]);

  function parseRangeToDates(rangeString) {
    if (!rangeString) return { startDate: null, endDate: null };

    const [startStr, endStr] = rangeString.split(" - ");

    const parseDDMMYYYY = (s) => {
      const [day, month, year] = s.split("/").map(Number);
      return new Date(year, month - 1, day);
    };

    return {
      startDate: parseDDMMYYYY(startStr),
      endDate: parseDDMMYYYY(endStr),
    };
  }

  const isFYDateSet = useRef(false);

  useEffect(() => {
    if (!DataMain || !FinancialYear) return;
    if (isFYDateSet.current) return;

    let matchedYear = null;

    DataMain?.AC_Year_List?.forEach((el) => {
      if (el.AcYearID === Number(FinancialYear)) {
        matchedYear = el.AcYear;
      }
    });

    if (matchedYear) {
      const { startDate, endDate } = parseRangeToDates(matchedYear);

      setDateRange([
        {
          startDate,
          endDate,
          key: "selection",
        },
      ]);

      isFYDateSet.current = true;
    }
  }, [DataMain, FinancialYear]);

  const safeFormat = (date) => {
    if (!date || isNaN(new Date(date))) return "";
    return format(new Date(date), "yyyy-MM-dd");
  };

  const startDate = dateRange?.[0]?.startDate;
  const endDate = dateRange?.[0]?.endDate;

  const [filter, setFilter] = useState({
    itemSubGroup: [],
    machineGroup: [],
    itemGroup: [],
    itemName: [],
  });

  const [search, setSearch] = useState({
    itemGroup: "",
    itemName: "",
    itemSubGroup: "",
  });

  const itemNameList =
    StoreFiltersdata?.Inwarditem?.map((item) => ({
      label: item.itemname,
      value: item.itemid,
    })) || [];

  const itemGroupList =
    StoreFiltersdata?.ItemGroup?.map((item) => ({
      label: item.ItemGroupName,
      value: item.ItemGroupID,
    })) || [];

  const itemSubGroupList =
    StoreFiltersdata?.ItemSGroup?.map((item) => ({
      label: item.ItemSubGroupName,
      value: item.ItemSubGroupID,
    })) || [];

  const isApiCalled = useRef(false);

  useEffect(() => {


    if (!startDate || !endDate) return;

    if (isApiCalled.current) return;

    isApiCalled.current = true;

    dispatch(StoreFilters());

    dispatch(
      ItemVsSupplier({
        firm: Firm,
        Acyear: FinancialYear,
        StartDate: safeFormat(startDate, "yyyy-MM-dd"),
        EndDate: safeFormat(endDate, "yyyy-MM-dd"),
      }),
    );
  }, [Firm, FinancialYear, startDate, endDate]);

  const columns = [
    { label: "Sr. No.", key: "srNumber", align: "center" },
    {
      label: "Account Name",
      key: "AcName",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    { label: "Apr", key: "April", align: "right", format: "true" },
    { label: "May", key: "May", align: "right", format: "true" },
    { label: "Jun", key: "June", align: "right", format: "true" },
    { label: "Jul", key: "July", align: "right", format: "true" },
    { label: "Aug", key: "August", align: "right", format: "true" },
    { label: "Sep", key: "September", align: "right", format: "true" },
    { label: "Oct", key: "October", align: "right", format: "true" },
    { label: "Nov", key: "November", align: "right", format: "true" },
    { label: "Dec", key: "December", align: "right", format: "true" },
    { label: "Jan", key: "January", align: "right", format: "true" },
    { label: "Feb", key: "February", align: "right", format: "true" },
    { label: "Mar", key: "March", align: "right", format: "true" },

    { label: "Total Qty", key: "TotalQty", align: "right", format: "true" },
  ];

  const initialData = (ItemVsSupplierdata?.PartyWise || []).map((row) => ({
    AcName: row.AcName,
    April: row.AprilQty,
    May: row.MayQty,
    June: row.JunQty,
    July: row.JulyQty,
    August: row.AugQty,
    September: row.SepQty,
    October: row.OctQty,
    November: row.NovQty,
    December: row.DecQty,
    January: row.JanQty,
    February: row.FebQty,
    March: row.MarchQty,
    TotalQty: row.TotalInwQty,
  }));

  const columns1 = [
    { label: "Sr. No.", key: "srNumber", align: "center" },
    {
      label: "Item Name",
      key: "ItemName",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    { label: "Apr", key: "April", align: "right", format: "true" },
    { label: "May", key: "May", align: "right", format: "true" },
    { label: "Jun", key: "June", align: "right", format: "true" },
    { label: "Jul", key: "July", align: "right", format: "true" },
    { label: "Aug", key: "August", align: "right", format: "true" },
    { label: "Sep", key: "September", align: "right", format: "true" },
    { label: "Oct", key: "October", align: "right", format: "true" },
    { label: "Nov", key: "November", align: "right", format: "true" },
    { label: "Dec", key: "December", align: "right", format: "true" },
    { label: "Jan", key: "January", align: "right", format: "true" },
    { label: "Feb", key: "February", align: "right", format: "true" },
    { label: "Mar", key: "March", align: "right", format: "true" },

    { label: "Total Qty", key: "TotalQty", align: "right", format: "true" },
  ];

  const initialData1 = (ItemVsSupplierdata?.ItemWise || []).map((row) => ({
    ItemName: row.itemname,
    April: row.AprilQty,
    May: row.MayQty,
    June: row.JunQty,
    July: row.JulyQty,
    August: row.AugQty,
    September: row.SepQty,
    October: row.OctQty,
    November: row.NovQty,
    December: row.DecQty,
    January: row.JanQty,
    February: row.FebQty,
    March: row.MarchQty,

    TotalQty: row.TotalInwQty,
  }));

  const columns2 = [
    {
      label: "AcName",
      key: "AcName",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    {
      label: "Month Name",
      key: "MonthName",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    { label: "Min Rate", key: "MinInwRate", align: "right", format: "true" },
    { label: "Max Rate", key: "MaxInwRate", align: "right", format: "true" },
    {
      label: "Different Rate",
      key: "DiffRate",
      align: "right",
      format: "true",
    },
  ];

  const initialData2 = (ItemVsSupplierdata?.MinMaxRate || []).map((row) => ({
    AcName: row?.AcName ?? "",
    MonthName: row?.MonthName ?? "",
    MinInwRate: row?.MinRate ?? 0,
    MaxInwRate: row?.MaxRate ?? 0,
    DiffRate: row?.DiffRate ?? 0,
  }));

  const handleApplyFilter = () => {
    dispatch(ItemVsSupplierFun());
    dispatch(
      ItemVsSupplier({
        firm: Firm,
        Acyear: FinancialYear,
        ItemIDs: selectedItemNameId.length > 0 ? selectedItemNameId.toString() : "",
        ItemGrpIDs:
          selectedItemGroupId.length > 0 ? selectedItemGroupId.toString() : "",
        ItemSubGrpIDsIDs:
          selectedItemSubGroupId.length > 0 ? selectedItemSubGroupId.toString() : "",
        StartDate: safeFormat(startDate),
        EndDate: safeFormat(endDate),
      }),
    );

    setShowFilter(false);
  };



  const handleApplyFilter1 = () => {
    dispatch(ItemVsSupplierFun());
    dispatch(
      ItemVsSupplier({
        firm: Firm,
        Acyear: FinancialYear,
        ItemIDs: filter.itemName.length > 0 ? filter.itemName.toString() : "",
        ItemGrpIDs:
          filter.itemGroup.length > 0 ? filter.itemGroup.toString() : "",
        ItemSubGrpIDsIDs:
          filter.itemSubGroup.length > 0 ? filter.itemSubGroup.toString() : "",
        StartDate: safeFormat(startDate),
        EndDate: safeFormat(endDate),
      }),
    );

    setShowFilter(false);
  };


  if (!StoreFiltersdata) {
    return (
      <div className="flex justify-center items-center h-screen">
        <Loader />
      </div>
    );
  }

  if (!ItemVsSupplierdata || ItemVsSupplierdata === "no") {
    return (
      <div className="flex justify-center items-center h-screen">
        <Loader />
      </div>
    );
  }

  const toggleItem = (type, item) => {
    setFilter((prev) => {
      const selected = prev[type] || [];

      return {
        ...prev,
        [type]: selected.includes(item.value)
          ? selected.filter((i) => i !== item.value)
          : [...selected, item.value],
      };
    });
  };

  const selectAll = (type, items) => {
    const allIds = items.map((i) => i.value);

    setFilter((prev) => ({
      ...prev,
      [type]: prev[type]?.length === items.length ? [] : allIds,
    }));
  };

  const handleSearch = (type, value) => {
    setSearch((prev) => ({
      ...prev,
      [type]: value,
    }));
  };

  const FilterPanel = () => (
    <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
      <div>
        <div
          style={{
            backgroundColor:
              isdark === "light" ? iscolour?.Colour8 : iscolourDark?.Colour11,
            padding: "13px 20px",
            borderRadius: "12px 12px 0px 0px",
          }}
        >
          <h3
            style={{
              fontWeight: "700",
              fontSize: "18px",
              margin: 0,
              color:
                isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour1,
              alignItems: "center",
              display: "flex",
            }}
          >
            {" "}
            Date Range
          </h3>
        </div>
        <div
          style={{
            border: `2px solid ${isdark === "light" ? iscolour?.Colour4 : iscolourDark?.Colour6}`,
            padding: "15px",
            marginBottom: "15px",
            background:
              isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour3,
            borderRadius: "0px 0px 12px 12px",
          }}
        >
          <div
            onClick={() => setShowDatePicker(true)}
            style={{
              marginTop: "8px",
              padding: "10px",
              border: `2px solid ${isdark === "light" ? iscolour?.Colour4 : iscolourDark?.Colour6}`,
              borderRadius: "10px",
              cursor: "pointer",
              textAlign: "center",
              color: isdark === "light" ? "#000" : "#FFF",
            }}
          >
            {dateRange?.[0]?.startDate && dateRange?.[0]?.endDate
              ? `${format(dateRange[0].startDate, "yyyy-MM-dd")} - ${format(dateRange[0].endDate, "yyyy-MM-dd")}`
              : "Select Date Range"}
          </div>
        </div>
      </div>

      <MaintenanceFilterBox
        title="ItemSub Group"
        items={itemSubGroupList}
        search={search.itemSubGroup}
        setSearch={(val) => handleSearch("itemSubGroup", val)}
        selectedItems={filter.itemSubGroup}
        toggleItem={(item) => toggleItem("itemSubGroup", item)}
        selectAll={() => selectAll("itemSubGroup", itemSubGroupList)}
      />

      <MaintenanceFilterBox
        title="Item Group"
        items={itemGroupList}
        search={search.itemGroup}
        setSearch={(val) => handleSearch("itemGroup", val)}
        selectedItems={filter.itemGroup}
        toggleItem={(item) => toggleItem("itemGroup", item)}
        selectAll={() => selectAll("itemGroup", itemGroupList)}
      />

      <MaintenanceFilterBox
        title="Item Name"
        items={itemNameList}
        search={search.itemName}
        setSearch={(val) => handleSearch("itemName", val)}
        selectedItems={filter.itemName}
        toggleItem={(item) => toggleItem("itemName", item)}
        selectAll={() => selectAll("itemName", itemNameList)}
      />

      <button
        onClick={handleApplyFilter1}
        style={{
          padding: "12px",
          backgroundColor:
            isdark === "light" ? iscolour?.Colour8 : iscolourDark?.Colour11,
          color: "#fff",
          width: "100%",
          borderRadius: "12px",
          fontWeight: "700",
          // height: "45px",
          padding: "12px",
          border: "none",
        }}
      >
        Apply Filter
      </button>
    </div>
  );

  return (
    <div
      style={{
        padding: "16px",
        background:
          isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour1,
        minHeight: "100vh",
      }}
    >
      {/* <h2 style={{ fontWeight: "700" }}>Item Supplier Analysis</h2> */}

      <div className="d-lg-none d-flex justify-content-end mb-3">
        <Button
          onClick={() => setShowFilter(true)}
          style={{
            backgroundColor:
              isdark === "light" ? iscolour?.Colour8 : iscolourDark?.Colour11,
            color:
              isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour3,
            border: "none",
            borderRadius: "10px",
            padding: "8px 12px",
            boxShadow: "0 4px 10px rgba(0,0,0,0.18)",
          }}
        >
          <FiMenu size={22} />
        </Button>
      </div>

      <Offcanvas
        show={showFilter}
        onHide={() => setShowFilter(false)}
        placement="start"
        style={{
          background:
            isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour1,
        }}
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title
            style={{ color: isdark === "light" ? "#000" : "#fff" }}
          >
            Filters
          </Offcanvas.Title>
        </Offcanvas.Header>

        <Offcanvas.Body>
          <FilterPanel />
        </Offcanvas.Body>
      </Offcanvas>

      <div
        className="d-none d-lg-block"
        style={{
          backgroundColor:
            isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour1,
          padding: "15px",
          borderRadius: "12px",
          border: `2px solid ${isdark === "light" ? iscolour?.Colour4 : iscolourDark?.Colour8
            }`,
        }}
      >
        <Row className="g-2 align-items-end">
          <Col xs={12} sm={6} md={6} lg={6} xl={3}>
            <div>
              <h3
                style={{
                  color: isdark === "light" ? iscolour?.Colour11 : "#fff",
                  fontWeight: "700",
                  fontSize: "13px",
                  marginBottom: "5px",
                }}
              >
                Date Range
              </h3>
            </div>
            <div>
              <div
                onClick={() => setShowDatePicker(true)}
                className="date"
                style={{
                  padding: " 12px 20px",
                  borderRadius: "12px",
                  cursor: "pointer",
                  textAlign: "center",
                  border: `1px solid ${isdark === "light" ? iscolour?.Colour6 : iscolourDark?.Colour7}`,
                  color: isdark === "light" ? "#000" : "#fff",
                }}
              >
                {dateRange?.[0]?.startDate && dateRange?.[0]?.endDate
                  ? `${format(dateRange[0].startDate, "dd/MM/yyyy")} - ${format(dateRange[0].endDate, "dd/MM/yyyy")}`
                  : "Select Date Range"}
              </div>
            </div>
          </Col>

          <Col xs={12} sm={6} md={6} lg={6} xl={3}>
            <MaintenanceDropDwonFilterBox
              label="ItemSub Group"
              data={itemSubGroupList}
              selectedValue={selectedItemSubGroup}
              setSelectedValue={setSelectedItemSubGroup}
              selectedId={selectedItemSubGroupId}
              setSelectedId={setSelectedItemSubGroupId}
              placeholder="Select ItemSub Group" />
          </Col>

          <Col xs={12} sm={6} md={6} lg={6} xl={3}>
            <MaintenanceDropDwonFilterBox
              label="Item Group"
              data={itemGroupList}
              selectedValue={selectedItemGroup}
              setSelectedValue={setSelectedItemGroup}
              selectedId={selectedItemGroupId}
              setSelectedId={setSelectedItemGroupId}
              placeholder="Select Item Group" />
          </Col>

          <Col xs={12} sm={6} md={6} lg={6} xl={3}>
            <MaintenanceDropDwonFilterBox
              label="Item Name"
              data={itemNameList}
              selectedValue={selectedItemName}
              setSelectedValue={setSelectedItemName}
              selectedId={selectedItemNameId}
              setSelectedId={setSelectedItemNameId}
              placeholder="Select Item Name" />
          </Col>
          <Col
            xs={12}
            sm={12}
            md={12}
            lg={12}
            xl={12}
            className="mt-3 hover-scale-btn "
          >
            <button
              onClick={handleApplyFilter}
              style={{
                padding: "12px",
                backgroundColor:
                  isdark === "light"
                    ? iscolour?.Colour7
                    : iscolourDark?.Colour7,
                color: "#fff",
                width: "100%",
                borderRadius: "12px",
                fontWeight: "700",
                // height: "45px",
                padding: "12px",
                border: "none",
              }}
            >
              Apply Filter
            </button>
          </Col>
        </Row>
      </div>

      <div style={{ display: "flex", gap: "10px", margin: "20px 0 10px" }}>
        {["PARTYWISE", "ITEMWISE", "PARTY ITEMWISE"].map((btn) => (
          <button
            key={btn}
            onClick={() => setActiveTable(btn)}
            style={{
              flex: 1,
              height: "58px",
              borderRadius: "12px",
              cursor: "pointer",
              fontWeight: "600",
              border: `2px solid ${isdark === "light" ? iscolour?.Colour6 : iscolourDark?.Colour11
                }`,
              background:
                activeTable === btn
                  ? isdark === "light"
                    ? iscolour?.Colour8
                    : iscolourDark?.Colour11
                  : isdark === "light"
                    ? iscolour?.Colour1
                    : iscolourDark?.Colour2,
              color:
                activeTable === btn
                  ? isdark === "light"
                    ? iscolour?.Colour1
                    : iscolourDark?.Colour1
                  : isdark === "light"
                    ? "#000"
                    : "#fff   ",
            }}
          >
            {btn}
          </button>
        ))}
      </div>

      <div
        style={{
          borderRadius: "12px",
          overflow: "hidden",
          marginTop: "10px",
          boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
        }}
      >
        <div
          style={{
            padding: "14px",
            background:
              isdark === "light" ? iscolour?.Colour8 : iscolourDark?.Colour11,
            color: "#fff",
            fontWeight: "600",
            fontSize: "18px",
            margin: 0,
            letterSpacing: "1px",
          }}
        >
          {activeTable}
        </div>

        {activeTable === "PARTYWISE" && (
          <MaintenanceTable columns={columns} data={initialData} />
        )}

        {activeTable === "ITEMWISE" && (
          <MaintenanceTable columns={columns1} data={initialData1} />
        )}

        {activeTable === "PARTY ITEMWISE" && (
          <MaintenanceParentChild
            data={initialData2}
            columns={columns2}
            parentKey="AcName"
          />
        )}
      </div>

      {showDatePicker && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 99999,
          }}
          onClick={() => setShowDatePicker(false)}
        >
          <MaintenanceCelender
            isdark={isdark}
            iscolour={iscolour}
            iscolourDark={iscolourDark}
          />
          <div
            style={{
              background:
                isdark === "light" ? iscolour?.Colour3 : iscolourDark?.Colour3,

              borderRadius: "20px",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <Calendar
              className="custom-calendar"
              selectRange={true}
              onChange={(value) => {
                if (Array.isArray(value)) {
                  setDateRange([
                    {
                      startDate: value[0],
                      endDate: value[1],
                      key: "selection",
                    },
                  ]);
                }
              }}
              value={
                dateRange?.[0]?.startDate && dateRange?.[0]?.endDate
                  ? [dateRange[0].startDate, dateRange[0].endDate]
                  : null
              }
            />

            <div
              className="date-picker-footer"
              style={{
                textAlign: "center",
                marginTop: "15px",
                padding: "12px",
                background:
                  isdark === "light"
                    ? iscolour?.Colour3
                    : iscolourDark?.Colour3,
                borderRadius: "0 0 20px 20px",
              }}
            >
              <button
                onClick={() => setShowDatePicker(false)}
                style={{
                  padding: "10px",
                  borderRadius: "12px",
                  border: "none",
                  cursor: "pointer",
                  fontWeight: "700",
                  color: "#fff",
                  background:
                    isdark === "light"
                      ? iscolour?.Colour8
                      : iscolourDark?.Colour11,
                  boxShadow: "0 4px 10px rgba(0,0,0,0.25)",
                  transition: "0.2s ease",
                }}
                onMouseEnter={(e) => {
                  e.target.style.opacity = "0.85";
                  e.target.style.transform = "scale(1.05)";
                }}
                onMouseLeave={(e) => {
                  e.target.style.opacity = "1";
                  e.target.style.transform = "scale(1)";
                }}
              >
                Done
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ItemSupllierAnalysis;
